// extracted by mini-css-extract-plugin
export var carouselContainer = "PromotedTreatments-module--carouselContainer--da175";
export var contentContainer = "PromotedTreatments-module--contentContainer--e27cd";
export var headingAligment = "PromotedTreatments-module--headingAligment--30708";